module.exports = __webpack_public_path__ + "static/laptop-77a9276ff1da5578238cd3c1c56736ca.png";